import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "estimates-received-main tw-h-full tw-w-full tw-pb-2 tw-box-border" }

import EstimateReceivedPreview from "@/modules/project/components/screens/EstimateReceivedPreview.vue";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import CommonLoader from "@/core/components/CommonLoader.vue";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const __default__ = {
  name: "EstimatesReceivedMainComponent",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

// import EstimatesReceivedList from "@/modules/project/components/screens/EstimatesReceivedList.vue";
const store = useStore();
const route = useRoute();
const isLoading = ref(true);
const estimateAllDetails = ref(null) as any;
onMounted(async () => {
  let estimateId;
  if (route.params && route.params.estimateId) {
    estimateId = route.params.estimateId;
  }
  if (estimateId) {
    try {
      isLoading.value = true;
      const response = await store.dispatch(
        `${TRADE_ESTIMATE_STORE}/setTradeEstimateDetails`,
        {
          projectEstimateId: estimateId,
        }
      );

      estimateAllDetails.value = response;
    } catch (error) {
      console.log();
    } finally {
      isLoading.value = false;
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(CommonLoader, {
          key: 0,
          loading: isLoading.value
        }, null, 8, ["loading"]))
      : _createCommentVNode("", true),
    (estimateAllDetails.value && !isLoading.value)
      ? (_openBlock(), _createBlock(EstimateReceivedPreview, {
          key: 1,
          details: estimateAllDetails.value
        }, null, 8, ["details"]))
      : _createCommentVNode("", true)
  ]))
}
}

})